import { BaseModel } from '../../models/base.model';

export class MessageResponse extends BaseModel<MessageResponse> {

    public imageUrl: string;
    public links: Links[];
    public message: string;

    constructor(partial?: Partial<MessageResponse>) {
        super({
            imageUrl: undefined,
            links: undefined,
            message: undefined
        }, partial);
    }
}

export class Links extends BaseModel<Links> {

    public retry: boolean;

    public title: string;

    public url: string;

    constructor(partial?: Partial<Links>) {
        super({
            retry: false,
            title: undefined,
            url: undefined
        }, partial);
    }
}
